module.exports = __webpack_public_path__ + "img/calendar-minus.12f96f21.svg";